import { readLocalStorage, writeLocalStorage } from "./localStoragePreference.ts";

const LOCAL_STORAGE_KEY = "swmm-sidebar-visible";

/** The element browser tree — primary navigation, same as the real desktop GUI's own Study Area browser panel — so a first-time visitor (nothing saved yet) sees it visible, not hidden. */
export function readSavedSidebarVisible(): boolean {
  const saved = readLocalStorage(LOCAL_STORAGE_KEY);
  return saved === null ? true : saved === "true";
}

export function saveSidebarVisible(visible: boolean): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, String(visible));
}
